var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "69px",
    viewBox: "0 0 52 69",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Tablet_717954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.56251C0 2.06119 2.06118 7.60417e-06 4.5625 7.60417e-06L47.1458 0C49.6472 0 51.7083 2.06118 51.7083 4.5625L51.7083 63.875C51.7083 66.3763 49.6472 68.4375 47.1458 68.4375L4.5625 68.4375C2.06118 68.4375 0 66.3763 0 63.875L0 4.56251ZM4.5625 3.04167L47.1458 3.04167C48.0147 3.04167 48.6667 3.69366 48.6667 4.56251L48.6667 6.08334L3.04167 6.08334L3.04167 4.56251C3.04167 3.69366 3.69365 3.04167 4.5625 3.04167ZM48.6667 9.12501L3.04167 9.12501L3.04167 56.2708L48.6667 56.2708L48.6667 9.12501ZM3.04167 59.3125L48.6667 59.3125L48.6667 63.875C48.6667 64.7439 48.0147 65.3959 47.1458 65.3959L4.5625 65.3959C3.69365 65.3959 3.04167 64.7439 3.04167 63.875L3.04167 59.3125ZM24.3333 62.3542C24.3333 61.5142 25.0142 60.8333 25.8542 60.8333C26.6941 60.8333 27.375 61.5142 27.375 62.3542C27.375 63.1941 26.6941 63.875 25.8542 63.875C25.0142 63.875 24.3333 63.1941 24.3333 62.3542Z",
    transform: "translate(0 0.2754077)",
    id: "Shape",
    fill: "#FFDA1A",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletIcon);
export default __webpack_public_path__ + "static/media/tablet-icon.63d1e5c00e10e5ad1346e32a22266973.svg";
export { ForwardRef as ReactComponent };